import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { TextInputControl } from './TextInputControl';
import { textToFfCanvas } from '@gift/text-core/textToFfCanvas';
import { TextVariableOptions } from '@gift/text-core/TextVariableOptions';
import { TextVariableInput } from '@gift/text-core/TextVariableInput';

export const textWebsitePlugin: WebsitePlugin.Variable<TextVariableOptions, TextVariableInput> = {
    pluginId: 'text',
    InputControl: TextInputControl,
    toFfCanvas: textToFfCanvas
};